import { useEffect, useState } from "react";

export const TAGLINE = ["Give Wings to Your Dreams", "अपने सपनों को पंख दें"];
export const SUPPORT_LINE = ["AI • Robotics • Drones — Learn. Build. Soar.", "AI • रोबोटिक्स • ड्रोन — सीखें। बनाएँ। उड़ान भरें।"];
export const OFFER_END = new Date("2026-11-14T23:59:59+05:30");
export const OFFER_END_LABEL = ["14 November 2026", "14 नवंबर 2026"];
export const KITS_NOTE = ["Fee covers classroom + lab assistance only. Kits are not included.", "फ़ीस में केवल क्लासरूम + लैब सहायता शामिल है। किट शामिल नहीं हैं।"];
export const CLASS_FEES = [
  { classes: ["6", "7"], label: ["Class 6–7", "कक्षा 6–7"], fee: 4999 },
  { classes: ["8", "9", "10"], label: ["Class 8–9–10", "कक्षा 8–9–10"], fee: 6999 },
  { classes: ["11", "12"], label: ["Class 11–12", "कक्षा 11–12"], fee: 10999 },
];
export const fmtFee = (n) => `₹${n.toLocaleString("en-IN")}`;
export const feeFor = (cls) => CLASS_FEES.find((f) => f.classes.includes(cls))?.fee || 0;
export const sectionFor = (cls) => (["6", "7", "8"].includes(cls) ? "A" : ["9", "10"].includes(cls) ? "B" : "C");

export const useCountdown = (target) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  const ms = Math.max(new Date(target).getTime() - now, 0);
  const s = Math.floor(ms / 1000);
  return { ms, d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
};

export const pad = (n) => String(n).padStart(2, "0");

// Referral code from a shared link (?ref=ABC123), kept for 30 days so it survives browsing around.
export const takeRef = (params) => {
  const fromUrl = (params.get("ref") || "").trim().toUpperCase().slice(0, 12);
  if (fromUrl) localStorage.setItem("rs_ref", JSON.stringify({ code: fromUrl, at: Date.now() }));
  try {
    const saved = JSON.parse(localStorage.getItem("rs_ref") || "null");
    return saved && Date.now() - saved.at < 30 * 864e5 ? saved.code : "";
  } catch { return ""; }
};

// Legal entity that collects payments (matches the Razorpay account + settlement bank). Keep in sync with backend/billing_entity.py.
export const BILLING_ENTITY = "LUXERAY SMART HOMES PVT. LTD.";
export const GSTIN = "10AAGCL3821R1ZE";
export const GST_RATE = 18;
export const gstOn = (taxable) => Math.round((taxable * GST_RATE) / 100);
export const payable = (fee, pct = 0) => { const taxable = fee - Math.round((fee * pct) / 100); return taxable + gstOn(taxable); };
